/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-transit': {
    width: 9,
    height: 9,
    viewBox: '0 0 9 9',
    data: '<path pid="0" d="M8.327.568a.232.232 0 0 0-.262-.047L.53 3.991a.232.232 0 0 0 .022.431l2.315.792c.382.131.682.431.813.813l.793 2.316a.232.232 0 0 0 .43.022L8.373.83a.232.232 0 0 0-.046-.262z" _fill="#000" fill-rule="nonzero"/>'
  }
})
